<template lang="html">
  <div class="">
    <Card :show='1'>
      <span slot="show-title">New Permission</span>
      <span slot="card-title" class="card-title-spaced">
        New Permissions
      </span>
      <form class="" @submit.prevent='addPerm'>
        <FormField placeholder="Enter name" :value='newPerm.name' :onUpdate='e => { newPerm.name = e }' labelText='Permission Name' />
        <button type="submit" class="btn btn-primary">Create</button>
      </form>
    </Card>
    <div class="" v-if='loaded'>
      <ul class="perms-list">
        <li v-for='perm, permId in permsList'>
          <span class="perm-name">{{perm}}</span>
          <i class="fa fa-trash trash-btn" aria-hidden="true" @click='delPerm(permId, perm)'></i>
        </li>
      </ul>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      newPerm: {
        name: null
      },
      assignedPerms: {
      },
      notAssignedPerms: {
      },
      permsList: [],
      selectedRole: null,
      loaded: false
    }
  },
  created() {
    let proms = new Array(2)

    proms[0] = this.$store.dispatch('getPermsList')
      .then(perms => {
        this.permsList = perms
      })

    Promise.all(proms)
      .then(r => {
        this.loaded = true
      })
  },
  methods: {
    addPerm() {
      let form = this.newPerm
      this.$http.post(this.resources.Admin.newPerm, form)
        .then(r => r.json())
        .then(role => {
          this.notifySuccess(`New Permission '${form.name}' has been created`)
          this.newPerm.name = null
          this.permsList[role.id] = role.name
        })
        .catch(err => {
          this.notifyError("Could not insert perm.")
        })
    },
    delPerm(permId, permName) {
      let confirm = window.confirm(`Are you sure that you wish to delete perm ${permName}`)
      if(!confirm) {
        return false
      }
      this.$http.delete(this.resources.Admin.deletePerm(permId))
        .then(() => {
          this.$delete(this.permsList, permId)
        })
        .catch(err => {
          this.notifyError("Could not delete perm.")
        })
    }
  }
}
</script>

<style lang="css" scoped>
.perms-list {
  max-height: 300px;
  overflow-y: auto;
  border: 1px solid gainsboro;
  padding: 8px;
}
.perm-name {
  display: inline-block;
  width: 550px;
}
</style>



// WEBPACK FOOTER //
// src/views/admin/EditPermissions.admin.vue